import React from "react"
import camera_icon from "../../../../assets/images/ion_camera-sharp.svg"
import { Link } from "react-router-dom"

const EditGuestDatabase = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="py-2 border-top border-bottom">
                                <Link to="/guest-database" className="text-black d-flex align-items-center"><i class="bi bi-arrow-left-short me-2" style={{ fontSize: "1.5rem" }}></i>Edit Guest</Link>
                            </div>
                            <div className="row mt-4">
                                <div className="col-sm-12 col-lg-2 d-flex justify-content-center align-items-center">
                                    <img src={camera_icon} className="profile-icon-img" alt="camera-icon-img" />
                                </div>
                                <div className="col-sm-12 col-lg-5 mb-3 mb-lg-0">
                                    <div className="d-flex flex-column gap-3">
                                        <div>
                                            <label className="form-label">Name</label>
                                            <div className="form-group1">
                                                <select className="form-select" style={{
                                                    width: "fit-content"
                                                }}>
                                                    <option value="">Mr</option>
                                                    <option value="">Ms</option>
                                                    <option value="">Mrs</option>
                                                    <option value="">Dr</option>
                                                </select>
                                                <input type="text" className="form-control" />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="form-label">Phone</label>
                                            <input type="number" className="form-control" placeholder="1234567890" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-lg-5">
                                    <div className="d-flex flex-column gap-3">
                                        <div>
                                            <label className="form-label">Email</label>
                                            <input type="email" className="form-control" placeholder="example@gmail.com" />
                                        </div>
                                        <div>
                                            <label className="form-label">Mobile</label>
                                            <input type="email" className="form-control" placeholder="0987456321" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-3">
                                    <label className="form-label">Gender</label>
                                    <div className="d-flex gap-3">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="genderCheck" value="maleCheck" id="maleCheck" checked />
                                            <label class="form-check-label" for="maleCheck">
                                                Male
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="genderCheck" value="femaleCheck" id="femaleCheck" />
                                            <label class="form-check-label" for="femaleCheck">
                                                Female
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="genderCheck" value="otherCheck" id="otherCheck" />
                                            <label class="form-check-label" for="otherCheck">
                                                Other
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 mt-3">
                                    <div className="edit-guest-addr-field">
                                        <div className="mb-3">
                                            <label className="form-label">Address</label>
                                            <textarea className="form-control" rows="3"></textarea>
                                        </div>
                                        <div className="row row-gap-3">
                                            <div className="col-sm-12 col-lg-3">
                                                <label className="form-label">Country</label>
                                                <select className="form-select">
                                                    <option selected>Select Country</option>
                                                    <option>India</option>
                                                    <option>USA</option>
                                                </select>
                                            </div>
                                            <div className="col-sm-12 col-lg-3">
                                                <div>
                                                    <label className="form-label">State</label>
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-lg-3">
                                                <div>
                                                    <label className="form-label">City</label>
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-lg-3">
                                                <div>
                                                    <label className="form-label">Zip</label>
                                                    <input type="text" className="form-control" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                <div className="py-2 border-top border-bottom d-flex align-items-center gap-2">
                                    <i class="bi bi-caret-down-fill" style={{ fontSize: "1.2rem" }}></i>
                                    <h6 className="m-0 fw-semibold">INDENTITY INFORMATION</h6>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-sm-12 col-lg-2 d-flex justify-content-center align-items-center">
                                        <img src={camera_icon} className="profile-icon-img" alt="camera-icon-img" />
                                    </div>
                                    <div className="col-sm-12 col-lg-5 mb-3 mb-lg-0">
                                        <div className="d-flex flex-column gap-3">
                                            <div>
                                                <label className="form-label">ID Number</label>
                                                <input type="text" className="form-control" placeholder="ID Number" />
                                            </div>
                                            <div>
                                                <label className="form-label">Issuing Country</label>
                                                <select className="form-select">
                                                    <option selected>Issuing Country</option>
                                                    <option>None</option>
                                                    <option>None</option>
                                                </select>
                                            </div>
                                            <div>
                                                <label className="form-label">Expire Date</label>
                                                <input type="date" className="form-control" placeholder="ID Number" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-5">
                                        <div className="d-flex flex-column gap-3">
                                            <div>
                                                <label className="form-label">ID Type</label>
                                                <select className="form-select">
                                                    <option selected>Select</option>
                                                    <option>None</option>
                                                    <option>None</option>
                                                </select>
                                            </div>
                                            <div>
                                                <label className="form-label">Issuing City</label>
                                                <input type="text" className="form-control" placeholder="Issuing City" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h5 className="my-3 fw-semibold">PAYMENT METHOD</h5>
                                <div className="row row-gap-3">
                                    <div className="col-sm-12 col-lg-4">
                                        <div>
                                            <label className="form-label">Payment Method</label>
                                            <select className="form-select">
                                                <option selected>Select</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-4">
                                        <div>
                                            <label className="form-label">Direct Billing A/C</label>
                                            <select className="form-select">
                                                <option selected>Select</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <h5 className="mb-3 mt-4 fw-semibold">PERSONAL INFROMATION</h5>
                                <div className="row row-gap-3">
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Payment Method</label>
                                            <select className="form-select">
                                                <option selected>Select</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Birth Country</label>
                                            <select className="form-select">
                                                <option selected>India</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Nationality</label>
                                            <select className="form-select">
                                                <option selected>Nationality</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">VIP Status</label>
                                            <select className="form-select">
                                                <option selected>Select</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-gap-3 mt-4">
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Spouse Birth Date</label>
                                            <input type="date" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Wedding Anniversary</label>
                                            <input type="date" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Registration No</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-3">
                                        <div>
                                            <label className="form-label">Purpose of Visit</label>
                                            <select className="form-select">
                                                <option selected>Select</option>
                                                <option>None</option>
                                                <option>None</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditGuestDatabase